module.exports = __webpack_public_path__ + "static/media/change-playlist-icon.6b340ecc.svg";